import React from 'react';

const BuyButton = ({ label, href, cssClass, onClick, enableOnClick }) => (
    enableOnClick ? 
    <a className={cssClass} onClick={() => onClick()}>
        {label}
    </a>
    : <a className={cssClass} href={href}>
        {label}
    </a>
)

export default BuyButton;
